import { CwtApiConfig } from '@cawita/core-front/api';
import { CwtAssetConfig } from '@cawita/core-front/asset';
import { environment } from '../../environments/environment';

export const KatchaAssetConfig: CwtAssetConfig = {
    apiUrl: environment.assetUrl,
    protectedAssetPath: environment.protectedAssetUrl,
    publicAssetPath: environment.publicAssetPathUrl
}

export const KatchaApiConfig: CwtApiConfig = {
    apiUrl: environment.apiUrl,
    apiVersion: 3,
};